import React from "react";
import { Provider } from "react-redux";
import store from "../../stores/reduxStore";

import { ApolloProvider } from "@apollo/client";
import client from "../../helpers/apollo-client";
import { graphql } from "@apollo/client/react/hoc";
import gql from "graphql-tag";

import DashboardUploadsSection from "./active-uploads/dashboard-active-uploads-section";
import DashboardCollectionSection from "./collections/dashboard-collection-section";
import FetchCollections from "./collections/fetch-collections";
import Modal from "../../containers/modal";

class Dashboard extends React.Component {
    showIcons(userUploads) {
        return (
            userUploads.pendingCount > 0 ||
            userUploads.deniedCount > 0 ||
            userUploads.hasApprovedUploads
        );
    }

    render() {
        const { data } = this.props;

        if (data && data.userUploads && data.me) {
            return (
                <div>
                    <DashboardUploadsSection
                        username={data.me.username}
                        userUploads={data.userUploads}
                        showIcons={this.showIcons(data.userUploads)}
                    />
                    <FetchCollections
                        collectionLimit={1}
                        iconLimit={10}
                        userId={data.me.id}
                    >
                        <DashboardCollectionSection
                            showIcons={this.showIcons(data.userUploads)}
                            username={data.me.username}
                        />
                    </FetchCollections>
                </div>
            );
        }

        return null;
    }
}

const query = gql`
    query IconActiveUploads {
        userUploads: userIconUploadCounts {
            pendingCount
            deniedCount
            hasApprovedUploads
        }
        me: currentUser {
            id
            username
        }
    }
`;

Dashboard = graphql(query)(Dashboard);

export default function DashboardWrapper() {
    return (
        <Provider store={store}>
            <ApolloProvider client={client}>
                <Dashboard />
                <Modal />
            </ApolloProvider>
        </Provider>
    );
}
